import React from "react";

//components
import LoginForm from "./components/loginForm/LoginForm";
import Section from "../components/section/Section";

const Login = () => {
  return (
    <Section>
      <LoginForm />
    </Section>
  );
};

export default Login;
